import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiFaceSwapConfig } from '@/data/landingConfig/landingAiFaceSwapConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiFaceSwap } from './schemaObject';

interface Props {}
const AiFaceSwap: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiFaceSwap} />

			<LandingTemplate
				data={landingAiFaceSwapConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiFaceSwap()}
			/>
		</>
	);
};

export default AiFaceSwap;
